import { dataHooks } from '@wix/data-hooks'

export const wixIntrosTemplateDataHooks = dataHooks<{
  logo: {}
  footerControls: {}
}>('wix-intros-template')
